<template>
    <veui-tabs
        class="message-tabs"
        theme="ai"
        ui="xl"
        :active="active"
        @change="handleChangeTab"
    >
        <veui-tab
            v-for="item in messageTypeList"
            :key="item.name"
            :label="item.label"
            :name="item.name"
        >
            <template #label="{label,name}">
                <div class="message-tabs-label">
                    <span> {{ label }}</span>
                    <span v-if="totalMap[name] !== 0" class="count-icon">
                        {{ totalMap[name] | formatCount }}
                    </span>
                </div>
            </template>
        </veui-tab>
    </veui-tabs>
</template>

<script>
import {Tab, Tabs} from 'veui';
import {messageTypeList} from '../config';

export default {
    components: {
        'veui-tabs': Tabs,
        'veui-tab': Tab
    },
    props: {
        active: {
            type: String,
            default: 'system'
        },
        totalMap: {
            type: Object,
            default: () => {
                return {
                    system: 0,
                    personal: 0
                };
            }
        }
    },
    filters: {
        formatCount: function (num) {
            return num > 99 ? '99+' : `${num}`;
        }
    },
    data() {
        return {
            messageTypeList
        };
    },
    methods: {
        handleChangeTab({name}) {
            this.$emit('update:active', name);
            this.$emit('change', name);
        }
    }
};
</script>

<style lang="less" scoped>
.message-tabs {
    margin-top: 12px;
    margin-bottom: 24px;
    /deep/ .veui-ai-tabs-menu {
        height: 46px;
    }
    /deep/ .veui-ai-tabs-item-label-ellipsis {
        overflow: visible;

    }
    &-label {
        position: relative;
        line-height: 22px;
    }
    .count-icon {
        display: flex;
        min-width: 14px;
        height: 14px;
        padding: 0px 3px;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
        border-radius: 8px;
        background: var(--Red-7, #F53F3F);
        color: var(----G0, #FFF);
        font-size: 10px;
        font-weight: 500;
        line-height: 15px; /* 150% */
        position: absolute;
        top: 0;
        right: 0;
        transform: translate(100%, -50%);
    }
}
</style>